import {createAction} from '@reduxjs/toolkit';
import {ChangePasswordDTO, ForgotPasswordDTO, RegisterDTO} from 'typescript/dto/authDto';
import UpdateUserDTO from 'typescript/dto/userDto';
import {LoginPayload} from 'typescript/interfaces/LoginPayload';
import {withPayloadType} from 'typescript/types/PayloadType';

import {appNamespace} from './appSlice';

const loginUserACS = createAction(`${appNamespace}/loginUserACS`, withPayloadType<LoginPayload>());

const getUserACS = createAction(`${appNamespace}/getUserACS`, withPayloadType<string>());

const registerUserACS = createAction(`${appNamespace}/registerUserACS`, withPayloadType<RegisterDTO>());

const resetPasswordACS = createAction(
  `${appNamespace}/resetPasswordACS`,
  withPayloadType<{data: ForgotPasswordDTO; isResent?: boolean}>(),
);

const changePasswordACS = createAction(`${appNamespace}/changePasswordACS`, withPayloadType<ChangePasswordDTO>());

const updateUserACS = createAction(
  `${appNamespace}/updateUserACS`,
  withPayloadType<{id: string; data: UpdateUserDTO}>(),
);

export {loginUserACS, resetPasswordACS, changePasswordACS, updateUserACS, registerUserACS, getUserACS};
